import React, { useState } from 'react';
import Panel from '../../common/layout/Panel';
import FlowBuilder from './FlowBuilder';
import './automations.css';
import { create } from '../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const AutomationsCreate = () => {
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);
    const [automation, setAutomation] = useState({
        id: '1',
        name: 'New Automation',
        steps: [{
            id: 'trigger_1',
            type: 'trigger',
            title: 'Trigger',
            config: {
                triggerType: null
            },
            status: 'pending'
        }]
    });

    const isTriggerConfigured = () => {
        const trigger = automation.steps?.find(step => step.type === 'trigger');
        if (!trigger || !trigger.config?.triggerType) {
            return false;
        }

        // For specific_date_time trigger, check if all required fields are filled
        if (trigger.config.triggerType === 'specific_date_time') {
            return trigger.config.date && trigger.config.time && trigger.config.timezone;
        }

        return true;
    };

    const handleSave = async () => {
        if (!isTriggerConfigured()) {
            toast.error('Please configure the trigger before saving');
            return;
        }

        try {
            setSaving(true);
            const payload = {
                name: automation.name || 'New Automation',
                description: automation.description || '',
                trigger_type: automation.steps?.[0]?.config?.triggerType || null,
                trigger_config: automation.steps?.[0]?.config || null,
                steps: automation.steps?.filter(s => s.type !== 'trigger') || [],
                status: true,
            };
            const res = await create('/admin/automations', { data: payload });
            if (res.data?.result === 'OK') {
                toast.success('Automation saved');
                setTimeout(() => navigate('/automations'), 800);
            } else {
                toast.error('Failed to save automation');
            }
        } catch (e) {
            console.error('Failed to save automation', e);
            toast.error('Failed to save automation');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="automations-container">
            <ToastContainer position="top-right" autoClose={4000} />
            <div className="automations-header">
                <div className="automations-title">
                    <h2>{automation.name}</h2>
                </div>
                <div className="automations-actions">
                    <button 
                        className={`btn ${isTriggerConfigured() ? 'btn-primary' : 'btn-secondary'}`}
                        onClick={handleSave}
                        disabled={saving || !isTriggerConfigured()}
                        title={!isTriggerConfigured() ? 'Configure trigger to enable saving' : ''}
                    >
                        {saving ? 'Saving...' : 'Save Automation'}
                    </button>
                </div>
            </div>
            
            <Panel title="Flow Builder">
                <FlowBuilder 
                    automation={automation}
                    setAutomation={setAutomation}
                />
            </Panel>
        </div>
    );
};

export default AutomationsCreate;